import React, { useEffect, useRef, useState } from "react";
import style from "../../../LeftNavigation/DesignerControls/BasicControls.module.css";
import { useSelector, updateStateInRedux, useDispatch } from "../../../../Redux";
import { Button } from "react-bootstrap";
import { makeStyles } from "@material-ui/core/styles";
import ELEMENT from "../../../../UI/BasicFormControls/ELEMENT";
import { triggerEventCalls } from "../../../../ReusableComponents/Events/EventExecutionLogic";
// import { triggerEventCalls } from "../../ReusableComponents/Events/EventExecutionLogic";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Divider from "@material-ui/core/Divider";
import GreyCross from "../../../../Icons/GreyCross.svg";
import {
  getFormJsonFromStore,
  loadArabicImage,
  setMandatoryControls,
  updatedComponentInFormStates,
} from "../../IFormDesignerLogic";
import { useTranslation } from "react-i18next";
import { GetState, GetStateFromData } from "../../../CustomHooks/CustomHooks";
import { isMobile, isTablet } from "react-device-detect";
import { functions, generalError_fn } from "../../ApplicationAPI/applicationApi";
import { removeSubFormMetaDataWithoutRender } from "../../../../Redux/Actions/FormStateActions";
import { getHooksId } from "../../../../Resources/globalFunctions";
const useStyles = makeStyles({
  "@global": {
    "*::-webkit-input-placeholder": {
      color: "#606060",
    },
  },
  root: (prop) => ({ ...({...prop, position: "absolute !important" }), "& .MuiBackdrop-root": { ...prop, position: "absolute !important" } }),
  button: {
    position: "relative",
  },
  data: {
    fontSize: "15px",
    fontWeight: "bold",
  },
  dialog: {
    position: "absolute",
    height: (style) =>
      style?.current?.height ? `${style?.current?.height}` : style?.current?.SubformHeight ? ( style?.current?.SubformHeight + "%") : "440px",
    width: (style) =>
      style?.current?.width ? `${style?.current?.width}` : style?.current?.SubformWidth  ? ( style?.current?.SubformWidth + "%") : "800px",
    maxWidth: "100%",
    overflow: "hidden",
    direction:
      window?.psh_configs?.selectedLanguage === "ar" ||
      window?.psh_configs?.selectedLanguage === "ar-SA"
        ? "rtl"
        : "ltr",
  },
  subformButtonFontSize:{
    fontSize: style => `${
      style.pageStyle && style.pageStyle["FooterFontSize"] ? `${style.pageStyle["FooterFontSize"]}!important`:"12px !important"
  }`,
  borderRadius:(style) =>`${
    style.pageStyle && style.pageStyle["subformCornerRadius"] ? `${style.pageStyle["subformCornerRadius"]} !important`:"2px!important"
}`,
  },
  myCustomButton:{
    marginInline:'12px !important'
  },
  dialogTitle: {
    padding: 16,
    width: "100%",
    height: "50px",
    fontSize: "16px !important",
    fontWeight: "600",
  },
  dialogContent: {
    padding: 0, 
    width: "100%",
    overflow: "hidden",
    paddingRight: "6px",
    paddingLeft: "6px",
    paddingTop: "6px",
    // maxHeight: window.innerHeight < 1000 ? "500px": "",
    overflowY: "auto",
    "& #RootControl" : {
      overflow: "hidden",
    }
  },
  dialogActions: {
    height: 50,
    width: "100%",
    background: "#F5F5F5 0% 0% no-repeat padding-box",
    opacity: 1,
    padding: "11px 16px 11px",
  },
  btn1: {
    width: "104px",
    height: "28px",
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    border: "1px solid #C4C4C4",
    borderRadius: "2px",
    opacity: 1,
    padding: "5px 8px 6px 8px",
    marginRight: "5px",
    marginLeft: "5px",
  },
  btn2: {
    width: "124px",
    height: "28px",
    background: "#0072C6 0% 0% no-repeat padding-box",
    borderRadius: "2px",
    opacity: 1,
    padding: "5px 8px 6px 8px",
  },
  btnlabel: {
    textTransform: "none",
    font: "normal normal 600 12px/17px Open Sans",
  },

  closeIcon: {
    fontSize: 10,
  },
  tableContainer: {
    overflow: "auto",
    display: "flex",
    flexDirection: "column",
    marginRight: "2.02%",
    marginLeft: "3.16%",
    maxHeight: "252px",
    width: "94.8%",
    padding: "none",
    border: "1px solid #C4C4C4",
  },
  table: {
    minWidth: 300,
    flex: "auto",
  },
  tableHead: {
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    opacity: 1,
    textAlign: "left",
    font: "normal normal 600 14px/19px OpenSans",
    letterSpacing: "0px",
    color: "#606060",
    height: "36px",
  },
  tableBody: {
    textAlign: "left",
    font: "normal normal 600 14px/19px OpenSans",
    letterSpacing: "0px",
    color: "#000000",
  },
  tableHeadRow: {
    height: "36px",
  },
  tableBodyRow: {
    height: "36px",
  },
  tableHeadCell: {
    font: "normal normal 600 14px/19px  Open Sans",
    height: "auto",
    color: "#606060",
    textAlign:
      window?.psh_configs?.selectedLanguage === "ar" ||
      window?.psh_configs?.selectedLanguage === "ar-SA"
        ? "right"
        : "left",
  },
  tableBodyCell: {
    font: "normal normal 600 14px/19px Open Sans",
    height: "auto",
    textAlign:
      window?.psh_configs?.selectedLanguage === "ar" ||
      window?.psh_configs?.selectedLanguage === "ar-SA"
        ? "right"
        : "left",
    color: "#000000",
  },
  tableCheckCell: {
    padding: "10px 8px 0px 8px",
    width: "30px",
    borderRight: "1px solid #C4C4C4",
  },
  tableInput: {
    border: "1px solid #C4C4C4",
    borderRadius: "2px",
    opacity: 1,
  },
  dialogHead: {
    flex: 1,
    display: "flex",
  },
  dialogHead1: {
    textAlign: "left",
    fontSize: "14px",
    font: "normal normal 600 14px/19px Open Sans",
    fontWeight: "600",
  },
  dialogHead2: {
    flex: 1,
    display: "flex",
    justifyContent: "flex-end",
  },
  dialogHeadIcon: {
    height: "15px",
    width: "15px",
  },
  divider: {
    margin: "0 !important",
    backgroundColor: "#E4E4E4",
  },
  dialogContentHead: {
    margin: "2px",
    flex: 1,
    display: "flex",
  },
  allColumns: {
    textAlign: "left",
    font: "normal normal normal 12px/17px Open Sans",
    letterSpacing: "0px",
    color: "#606060",
    opacity: 1,
    fontSize: "12px",
    fontColor: "#C4C4C4",
    border: "1px solid #C4C4C4",
    height: "28px",
    width: "180px",
    margin: "8px 0px 8px 0px",
  },
  searchBox: {
    textAlign: "left",
    font: "normal normal normal 12px/17px Open Sans",
    letterSpacing: "0px",
    color: "#606060",
    opacity: 1,
    fontSize: "12px",
    fontColor: "#C4C4C4",
    border: "1px solid #C4C4C4",
    height: "28px",
    width: "200px",
    margin: "8px 0px 8px 0px",
  },
  searchInput: {
    fontSize: "12px",
    fontColor: "#C4C4C4",
    padding: "6px 0px 2px 8px",
    border: "none",
    outline: "none",
    width: "176px",
  },
  searchIcon: {
    paddingBottom: "5px",
  },
  rightArrowIcon: {
    padding: "0px",
    border: "1px solid #C4C4C4",
    margin: "8px 12px 8px 3px",
    width: "28px",
    height: "28px",
    backgroundColor: "white",
  },
  doneButton: {
    height: "28px !important",
    padding: "1px 6px !important",
    display: "flex !important",
    alignItems: "center !important",
    margin: "0px 0px 0px 8px !important",
    background: "#0072C6 0% 0% no-repeat padding-box !important",
    borderRadius: "2px!important",
    opacity: "1",
    whiteSpace: "nowrap !important",
    font: "normal normal 600 12px/17px Open Sans",
  },
});

const ButtonSubFormDialog = (props) => {
  const dispatch = useDispatch();
  const contexts = GetStateFromData();
  const { mandatoryControls } = GetState("mandatoryControls");
  const gridContexts = GetStateFromData(props.containerId, "data2");
  const { openCanvasForPreview } = gridContexts.gridStates;
  const { updateJson, setSubFormState, imageBaseURL,formMataData,canvasTop } = contexts.contexts;
  const [dialogStyle, setDialogStyle] = useState({});
  const { updatedComponentInFormState, removeAndUpdateComponentInFormState } =
    updateJson;

  const showLegacyId = window?.psh_configs?.show_legacy_ids === "Y"

  const subFormRef = useRef({
    height: "",
    width: "",
    showHeader: window?.newMicroFrontendData?.resizeSubFormData?.showHeader || false,
    showDone: window?.newMicroFrontendData?.resizeSubFormData?.showDone || true,
    headerTitle: window?.newMicroFrontendData?.resizeSubFormData?.headerTitle || "",
    doneTitle: window?.newMicroFrontendData?.resizeSubFormData?.doneTitle || "",
    headerTitleFontSize: window?.newMicroFrontendData?.resizeSubFormData?.headerTitleFontSize ||  "",
    headerTitleFontWeight: window?.newMicroFrontendData?.resizeSubFormData?.headerTitleFontWeight || "",
    headerTitleFontColor: window?.newMicroFrontendData?.resizeSubFormData?.headerTitleFontColor || "",
    headerTitleBackgroundColor: window?.newMicroFrontendData?.resizeSubFormData?.headerTitleBackgroundColor || "",
    doneTitleFontSize: window?.newMicroFrontendData?.resizeSubFormData?.doneTitleFontSize || "",
    doneTitleFontWeight: window?.newMicroFrontendData?.resizeSubFormData?.doneTitleFontWeight || "",
    doneTitleFontColor: window?.newMicroFrontendData?.resizeSubFormData?.doneTitleFontColor || "",
    doneTitleBackgroundColor: window?.newMicroFrontendData?.resizeSubFormData?.doneTitleBackgroundColor || "",
    SubformHeight:
      props?.subFormData?.pageStyle?.height
  ,
  SubformWidth:
    props?.subFormData?.pageStyle?.width
,
  });
  const { t } = useTranslation();
  const iformClientLoadedButtonSubform = useSelector((state) => state["iformClientLoadedButtonSubform"]);


  const updatedJSON = functions.readJson(getFormJsonFromStore(), props?.data?.id || props?.id);
  props.subFormData = updatedJSON.subform

  useEffect(() => {
    setMandatoryControls([])
    if(!window.location.pathname.includes("afb_subform") ){
      if (window.resizeSubForm) {
        const obj = window.resizeSubForm(props.data.id);
        if (props?.subFormData?.pageStyle?.height) {
          subFormRef.current.height = props?.subFormData?.pageStyle?.height + "%";
        }
        if (props?.subFormData?.pageStyle?.width) {
          subFormRef.current.width = props?.subFormData?.pageStyle?.width + "%";
        }
        if (obj?.Height) {
          subFormRef.current.height = obj.Height + "px";
        }
        if (obj?.Width) {
          subFormRef.current.width = obj.Width + "px";
        }
        if (
          obj?.showHeader ||
          obj?.showHeader === false ||
          obj?.showHeader === "false"
        ) {
          subFormRef.current.showHeader = obj.showHeader;
        }
        if (
          obj?.showDone ||
          obj?.showDone === false ||
          obj?.showDone === "false"
        ) {
          subFormRef.current.showDone = obj.showDone;
        }
        if (obj?.headerTitle) {
          subFormRef.current.headerTitle = obj.headerTitle;
        }
        if (obj?.headerTitleFontSize) {
          subFormRef.current.headerTitleFontSize = obj.headerTitleFontSize;
        }
        if (obj?.headerTitleFontColor) {
          subFormRef.current.headerTitleFontColor = obj.headerTitleFontColor;
        }
        if (obj?.headerTitleFontWeight) {
          subFormRef.current.headerTitleFontWeight = obj.headerTitleFontWeight;
        }
        if (obj?.headerTitleBackgroundColor) {
          subFormRef.current.headerTitleBackgroundColor =
            obj.headerTitleBackgroundColor;
        }
        if (obj?.doneTitle) {
          subFormRef.current.doneTitle = obj.doneTitle;
        }
        if (obj?.doneTitleFontSize) {
          subFormRef.current.doneTitleFontSize = obj.doneTitleFontSize;
        }
        if (obj?.doneTitleFontColor) {
          subFormRef.current.doneTitleFontColor = obj.doneTitleFontColor;
        }
        if (obj?.DoneTitleFontWeight) {
          subFormRef.current.doneTitleFontWeight = obj.doneTitleFontWeight;
        }
        if (obj?.DoneTitleBackgroundColor) {
          subFormRef.current.doneTitleBackgroundColor =
            obj.doneTitleBackgroundColor;
        }
      }
      if (window.subFormLoad) {
        try{
        window.subFormLoad(getHooksId(props?.data));
        }
        catch(error){
          const exceptionString = error?.stack || error?.message || String(error);
          generalError_fn(exceptionString, "Issue in custom code", 'error');
        }
        functions.updateJSON();
        const buttonJSON = functions.readJson(getFormJsonFromStore(),props.data.id);
        props.subFormData = JSON.parse(JSON.stringify(buttonJSON.subform));
        setRenderSubForm(prev => !prev);
      }
      else  {
        setRenderSubForm(prev => !prev);
      }
      var e = {
        type: "load",
      };
      if (
        props.subFormData &&
        props.subFormData.event &&
        props.subFormData.event.Events &&
        props.subFormData.event.Events.load
      ) {
        triggerEventCalls(e,{id:props.subFormData.id},props.subFormData.event,props.subFormData.elem_type,()=>{},contexts,props.containerId,props?.subFormData,"load");
      }
    }
  }, []);

  const [renderSubForm, setRenderSubForm] =useState(false);

  useEffect(() => {
    if(iformClientLoadedButtonSubform && window.location.pathname.includes("afb_subform")){
      setTimeout(() => {
        if (window.subFormLoad) {
            window.subFormLoad(getHooksId(props?.data));
            functions.updateJSON();
            // requestAnimationFrame(() => {
            //   const buttonJSON = functions.readJson(getFormJsonFromStore(),props.data.id);
            //   props.subFormData = JSON.parse(JSON.stringify(buttonJSON.subform));
            //   console.log("buttonSubform1", buttonJSON, props?.subFormData)
            //   updateRenderState(buttonJSON?.id)
            //   setRenderSubForm(prev => !prev);
            // })
          }
        //   else  {
        //     setRenderSubForm(prev => !prev);
        // }
        var e = {
          type: "load",
        };
        if (
          props.subFormData &&
          props.subFormData.event &&
          props.subFormData.event.Events &&
          props.subFormData.event.Events.load
        ) {
          triggerEventCalls(e,{id:props.subFormData.id},props.subFormData.event,props.subFormData.elem_type,()=>{},contexts,props.containerId,props?.subFormData,"load");
        }
    }, 1000)
    }
  }, [iformClientLoadedButtonSubform])

  useEffect(() => {
    if(props?.subFormData?.pageStyle?.ButtonBackgroundColor) {
      subFormRef.current.doneTitleBackgroundColor = props.subFormData.pageStyle.ButtonBackgroundColor;
    }
  },[props?.subFormData?.pageStyle?.ButtonBackgroundColor])

  useEffect(()=>{
    
    const suspenseLoaders = document.querySelectorAll(".suspenseLoader")
    console.log("suspenseLoaders",suspenseLoaders)
    if(suspenseLoaders?.length===0){
      // window.loading(false)
    }
  },[document.querySelectorAll(".suspenseLoader").length])
  
 const classes = useStyles({...subFormRef, pageStyle: props?.subFormData?.pageStyle});

 function handleClose(type) {
  if (type === "save") {
    const result = window.isComponentValidated("buttonSubform", {
      ...props.subFormData,
      validationType: "button",
      validationId: props.id
    });

    if (result) {
       let hookReturn = true;
      if (window.subformDoneClick) {
        try{
        hookReturn = window.subformDoneClick(getHooksId(props?.data));
        }
        catch(error){
          const exceptionString = error?.stack || error?.message || String(error);
          generalError_fn(exceptionString, "Issue in custom code", 'error');
        }
        functions.updateJSON();
      }
      if((hookReturn || hookReturn === undefined) && (props.data?.subform?.pageStyle?.ButtonSubformOverlayType === "modal"
      || props.data?.subform?.pageStyle?.ButtonSubformOverlayType === undefined)) {
        props.setOpenSub(false);
        setSubFormState(undefined);
      }
     if((hookReturn || hookReturn === undefined) && props.data?.subform?.pageStyle?.ButtonSubformOverlayType === "window") {
        window.close();
      }
    } 
    // else {
    //   setMandatoryControls([]);
    //   return;
    // }      
  } else {
    let restrictedOverlayClose = false;
   if(window.subformAllowRestrictedOverlay) {
    restrictedOverlayClose = window.subformAllowRestrictedOverlay(); // if true is retruned then do not close the modal
  }
  if((!restrictedOverlayClose && !type) || type === "cancel"){
    setSubFormState(undefined);
    setMandatoryControls([]);
     if(props.data?.subform?.pageStyle?.ButtonSubformOverlayType === "window") {
        window.close();
      }
    props.setOpenSub(false);
  }
  }
  dispatch(removeSubFormMetaDataWithoutRender({key: props?.containerId, value: props?.data?.id}));
  dispatch(updateStateInRedux({name: "openSubformCheck", key: props?.containerId, value: false}));
  // props.data.subform = props.subFormData;
  // updatedComponentInFormState();
}
  return (
    <div>
    {props?.subFormData?.pageStyle?.ButtonSubformOverlayType  === "window" ? (
    <div style={{ display: "flex", flexDirection: "column", height: "100dvh", overflow: "hidden" }}>
      {/* <Dialog
        classes={{ paper: classes.dialog, root: classes.root }}
        className="formBuilder_main_app"
        open={props.open}
        onClose={handleClose}
        style={stylezIndex1}
        // container={() => document.getElementById("canvasId")}
      > */}
        {subFormRef?.current?.showHeader || props?.subFormData?.pageStyle?.["Header"] === "true" ? (
          <>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                backgroundColor:`${
                  props?.subFormData?.pageStyle && props?.subFormData?.pageStyle["HeaderBackgroundColor"] ? props?.subFormData?.pageStyle["HeaderBackgroundColor"]:"#ffffff"
              }`,
              alignItems:"center"
             }}
            >
              <div
                style={{
                  margin: "12px",
                }}
                >
                {props?.subFormData?.pageStyle?.["iconFile"] ? (
                <img  style={{
                  width: props?.subFormJson?.pageStyle && props?.subFormJson?.pageStyle["HeaderFontSize"] ? props?.subFormJson?.pageStyle["HeaderFontSize"] : "15px",
                  height: props?.subFormJson?.pageStyle && props?.subFormJson?.pageStyle["HeaderFontSize"] ? props?.subFormJson?.pageStyle["HeaderFontSize"] : "15px",
                  marginRight: "10px",
                  marginLeft: "8px"
              }} src={`${imageBaseURL}${props?.subFormData?.pageStyle?.["iconFile"]}${loadArabicImage(imageBaseURL)}`} />
              ) : null}
                        <span style={{
                                                fontFamily:`${
                                                    props?.subFormData?.pageStyle && props?.subFormData?.pageStyle["HeaderFontFamily"] ? props?.subFormData?.pageStyle["HeaderFontFamily"]:"Open Sans"
                                                }`,
                                                fontSize:`${
                                                  (subFormRef?.current && subFormRef?.current?.headerTitleFontSize) || (props?.subFormData?.pageStyle && props?.subFormData?.pageStyle["HeaderFontSize"] ? props?.subFormData?.pageStyle["HeaderFontSize"]:"12px")
                                                }`,
                                                fontWeight:`${
                                                  (subFormRef?.current && subFormRef?.current?.headerTitleFontWeight) || (props?.subFormData?.pageStyle && props?.subFormData?.pageStyle["HeaderFontWeight"] ? props?.subFormData?.pageStyle["HeaderFontWeight"]:"SemiBold")
                                                }`,
                                                color:`${
                                                  (subFormRef?.current && subFormRef?.current?.headerTitleFontColor) || (props?.subFormData?.pageStyle && props?.subFormData?.pageStyle["HeaderFontColor"] ? props?.subFormData?.pageStyle["HeaderFontColor"]:"#606060")
                                                }`,
                                                fontStyle:`${
                                                    props?.subFormData?.pageStyle && props?.subFormData?.pageStyle["HeaderFontStyle"] ? props?.subFormData?.pageStyle["HeaderFontStyle"]:"SemiBold"
                                                }`,
                                                
                                            }}>
                                            {(subFormRef?.current && subFormRef?.current?.headerTitle) || (props.subFormData && props.subFormData?.pageStyle && props.subFormData?.pageStyle["SubformTitle"])}
                                            </span>
                                                        

              </div>
              <img
                onClick={() => {
                  handleClose();
                }}
                style={{
                  width: "12px",
                  height: "12px",
                  margin: "10px",
                  cursor: "pointer",
                }}
                alt="Close Icon"
                id={showLegacyId ? "closeButton" : `${props?.data?.style?.CustomId || props?.data?.id}_closeButton`}
                src={GreyCross}
                onKeyDown={(e) => e.key === "Enter" && handleClose()}
                tabIndex="0"
                aria-label="closeButton"
              />
            </div>
            <Divider className={classes.divider} tabIndex="0"/>
          </>
        ):null}
        {props?.subFormData?.pageStyle?.["Header"] === "false" || props?.subFormData?.pageStyle?.["Header"] === undefined ? (
          <img
          onClick={() => {
            handleClose()
          }}
          style={{
            height: "12px",
            margin: "10px",
            cursor: "pointer",
            position:"absolute",
            right:"0px",
            top:"0px",
            zIndex:2
          }}
          aria-label="closeButton"
          src={GreyCross}
          onKeyDown={(e) => e.key === "Enter" && handleClose()}
          tabIndex="0"
        /> 
        ): null}
        {/* <DialogContent
        classes={{ root: classes.dialogContent }}
          style={{
            width:"100%",
            backgroundColor: props?.data?.subform?.pageStyle?.SubformBackgroundColor
              ? props?.data?.subform?.pageStyle?.SubformBackgroundColor
              : "#FFFFFF",
          }}
        >
        </DialogContent> */} 
        <div style={{
            width: "100%",
            flex: 1,
            minHeight: 0,
            overflowY: "auto",
            overflowX: "hidden",
            backgroundColor: props?.data?.subform?.pageStyle?.SubformBackgroundColor
              ? props?.data?.subform?.pageStyle?.SubformBackgroundColor
              : "#FFFFFF",
          }}>
          <ELEMENT
            {...props}
            containerId={props.containerId}
            data={props.subFormData}
            isSubForm={true}
            buttonId={props.data.id}
          />
        </div>

        {subFormRef?.current?.showDone && props?.subFormData?.pageStyle?.["Footer"] === "true" ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "end",
              // marginRight: "10px",
              width:"100%",
              // marginBottom: "10px",
              // marginTop: "10px",
              flexShrink: 0,
              backgroundColor:`${
                props?.subFormData?.pageStyle && props?.subFormData?.pageStyle["FooterBackgroundColor"] ? props?.subFormData?.pageStyle["FooterBackgroundColor"]:"#EBEAE4"
            }`,
            }}
          >   
          { props?.subFormData?.pageStyle?.["showCancelButton"] === "true" ? 
                                               
            <Button
            id={showLegacyId ? `${props?.userDefinedControlId}_cancelbtn` : `${props?.data?.style?.CustomId || props?.data?.id}_cancelbtn`}
            variant="outlined"
             onClick={() => {
              handleClose("cancel")
            }}
             style={{position:"unset",left:"unset",bottom:"1px",
            //  backgroundColor:"lightgrey",
            
          color:`${
              props?.subFormData?.pageStyle && props?.subFormData?.pageStyle["subformCancelColor"] ? props?.subFormData?.pageStyle["subformCancelColor"]:"#C4C4C4"
          }`,
           borderRadius:`${
              props?.subFormData?.pageStyle && props?.subFormData?.pageStyle["subformCornerRadius"] ? props?.subFormData?.pageStyle["subformCornerRadius"]:"2px!important"
          }`,
          borderColor:`${
            props?.subFormData?.pageStyle && props?.subFormData?.pageStyle["subformCancelColor"] ? props?.subFormData?.pageStyle["subformCancelColor"]:"#C4C4C4"
        }`,}}>Cancel</Button>
             : null}                                
            <Button 
            id={showLegacyId ? `${props?.userDefinedControlId}_donebtn` : `${props?.data?.style?.CustomId || props?.data?.id}_donebtn`}
            onClick={() => handleClose("save")} variant="contained"
            className={classes.subformButtonFontSize}
            style={{  
              fontFamily:`${
              props?.subFormData?.pageStyle && props?.subFormData?.pageStyle["FooterFontFamily"] ? props?.subFormData?.pageStyle["FooterFontFamily"]:"Open Sans"
          }`,
          fontSize:`${
              props?.subFormData?.pageStyle && props?.subFormData?.pageStyle["FooterFontSize"] ? props?.subFormData?.pageStyle["FooterFontSize"]:"12px"
          }`,
          fontWeight:`${
              props?.subFormData?.pageStyle && props?.subFormData?.pageStyle["FooterFontStyleWeight"] ? props?.subFormData?.pageStyle["FooterFontStyleWeight"]:"SemiBold"
          }`,
          backgroundColor:`${
            props?.subFormData?.pageStyle && props?.subFormData?.pageStyle["ButtonBackgroundColor"] ? props?.subFormData?.pageStyle["ButtonBackgroundColor"]:"rgb(0, 114, 198)"
        }`,
          color:`${
              props?.subFormData?.pageStyle && props?.subFormData?.pageStyle["FooterFontColor"] ? props?.subFormData?.pageStyle["FooterFontColor"]:"white"
          }`,
          fontStyle:`${
              props?.subFormData?.pageStyle && props?.subFormData?.pageStyle["FooterFontStyle"] ? props?.subFormData?.pageStyle["FooterFontStyle"]:"SemiBold"
          }`,}}>
            {props.subFormData?.pageStyle["subformLabel"] ? 
            (props.subFormData?.pageStyle["subformLabel"] ) : t(`${"Done"}`)}
                                               
                                                </Button>
          </div>
        ):null}
      {/* </Dialog> */}
    </div>
    ):  <div>
      <Dialog
        classes={{ paper: classes.dialog, root: classes.root }}
        className="formBuilder_main_app"
        open={props.open}
        // onClose={handleClose}
        style={{ zIndex: 1298 }}
        container={() => document.getElementById("canvasId")}
      >
         {subFormRef?.current?.showHeader || props?.subFormData?.pageStyle?.["Header"] === "true" ? (
          <>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                backgroundColor:`${
                  props?.subFormData?.pageStyle && props?.subFormData?.pageStyle["HeaderBackgroundColor"] ? props?.subFormData?.pageStyle["HeaderBackgroundColor"]:"#ffffff"
              }`,
              alignItems:"center",
              zIndex: "1301",
             }}
            >
              <div
                style={{
                  margin: "12px",
                }}
                >
                {props?.subFormData?.pageStyle?.["iconFile"] ? (
                <img  style={{
                  width: props?.subFormJson?.pageStyle && props?.subFormJson?.pageStyle["HeaderFontSize"] ? props?.subFormJson?.pageStyle["HeaderFontSize"] : "15px",
                  height: props?.subFormJson?.pageStyle && props?.subFormJson?.pageStyle["HeaderFontSize"] ? props?.subFormJson?.pageStyle["HeaderFontSize"] : "15px",
                  marginRight: "10px",
                  marginLeft: "8px"
              }} src={`${imageBaseURL}${props?.subFormData?.pageStyle?.["iconFile"]}${loadArabicImage(imageBaseURL)}`} />
              ) : null}
                        <span style={{
                                                fontFamily:`${
                                                    props?.subFormData?.pageStyle && props?.subFormData?.pageStyle["HeaderFontFamily"] ? props?.subFormData?.pageStyle["HeaderFontFamily"]:"Open Sans"
                                                }`,
                                                fontSize:`${
                                                  (subFormRef?.current && subFormRef?.current?.headerTitleFontSize) || (props?.subFormData?.pageStyle && props?.subFormData?.pageStyle["HeaderFontSize"] ? props?.subFormData?.pageStyle["HeaderFontSize"]:"12px")
                                                }`,
                                                fontWeight:`${
                                                  (subFormRef?.current && subFormRef?.current?.headerTitleFontWeight) || (props?.subFormData?.pageStyle && props?.subFormData?.pageStyle["HeaderFontWeight"] ? props?.subFormData?.pageStyle["HeaderFontWeight"]:"SemiBold")
                                                }`,
                                                color:`${
                                                  (subFormRef?.current && subFormRef?.current?.headerTitleFontColor) || (props?.subFormData?.pageStyle && props?.subFormData?.pageStyle["HeaderFontColor"] ? props?.subFormData?.pageStyle["HeaderFontColor"]:"#606060")
                                                }`,
                                                fontStyle:`${
                                                    props?.subFormData?.pageStyle && props?.subFormData?.pageStyle["HeaderFontStyle"] ? props?.subFormData?.pageStyle["HeaderFontStyle"]:"SemiBold"
                                                }`,
                                                
                                            }}>
                                            { (subFormRef?.current && subFormRef?.current?.headerTitle) || (props.subFormData && props.subFormData?.pageStyle && props.subFormData?.pageStyle["SubformTitle"])}
                                            </span>
                                                        

              </div>
              <img
                onClick={() => {
                  handleClose();
                }}
                style={{
                  width: "12px",
                  height: "12px",
                  margin: "10px",
                  cursor: "pointer",
                }}
                alt="Close Icon"
                id={showLegacyId ? "closeButton" : `${props?.data?.style?.CustomId || props?.data?.id}_closeButton`}
                src={GreyCross}
                onKeyDown={(e) => e.key === "Enter" && handleClose()}
                tabIndex="0"
                aria-label="closeButton"
              />
            </div>
            <Divider className={classes.divider} tabIndex="0"/>
          </>
        ):null}
        {props?.subFormData?.pageStyle?.["Header"] === "false" || props?.subFormData?.pageStyle?.["Header"] === undefined ? (
          <div style={{ 
    position: "sticky", 
    top: 0, 
    display: "flex", 
    justifyContent: "flex-end", 
    background: "#fff", 
    zIndex: 10,
    height:"32px"
  }}>
    <img
      onClick={() => { handleClose() }}
      style={{
        height: "12px",
        margin: "10px",
        cursor: "pointer"
      }}
      src={GreyCross}
    />
  </div>
) : null}
        <DialogContent
        classes={{ root: [classes.dialogContent, "scrollable"].join(" ") }}
          style={{
            width:"100%",
            backgroundColor: props?.data?.subform?.pageStyle?.SubformBackgroundColor
              ? props?.data?.subform?.pageStyle?.SubformBackgroundColor
              : "#FFFFFF",
          }}
        > 
        {
          <ELEMENT
            {...props}
            containerId={props.containerId}
            data={props.subFormData}
            isSubForm={true}
            buttonId={props.data.id}
          />
        }
        </DialogContent>

        {subFormRef?.current?.showDone && (props?.subFormData?.pageStyle?.["Footer"] === "true" || props?.subFormData?.pageStyle?.["Footer"] === undefined) ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent:  window?.psh_configs?.selectedLanguage === "ar" ||
              window?.psh_configs?.selectedLanguage === "ar-SA" ? "flex-start" :"end",
              width:"100%",
              backgroundColor:`${
                props?.subFormData?.pageStyle && props?.subFormData?.pageStyle["FooterBackgroundColor"] ? props?.subFormData?.pageStyle["FooterBackgroundColor"]:"#EBEAE4"
            }`,
            }}
          >   
          { props?.subFormData?.pageStyle?.["showCancelButton"] === "true" ? 
                                               
            <Button
            id={showLegacyId ? `${props?.userDefinedControlId}_cancelbtn` : `${props?.data?.style?.CustomId || props?.data?.id}_cancelbtn`}
            variant="outlined"
             onClick={() => {
              handleClose("cancel")
            }}
            className={classes.myCustomButton}
             style={{position:"unset",left:"unset",bottom:"1px",
            //  backgroundColor:"lightgrey",
            
          color:`${
              props?.subFormData?.pageStyle && props?.subFormData?.pageStyle["subformCancelColor"] ? props?.subFormData?.pageStyle["subformCancelColor"]:"#C4C4C4"
          }`,
            borderRadius:`${
              props?.subFormData?.pageStyle && props?.subFormData?.pageStyle["subformCornerRadius"] ? props?.subFormData?.pageStyle["subformCornerRadius"]:"2px!important"
          }`,
                     borderColor:`${
            props?.subFormData?.pageStyle && props?.subFormData?.pageStyle["subformCancelColor"] ? props?.subFormData?.pageStyle["subformCancelColor"]:"#C4C4C4"
        }`,}}>Cancel</Button>
             : null}                                
            <Button 
            id={showLegacyId ? `${props?.userDefinedControlId}_donebtn` : `${props?.data?.style?.CustomId || props?.data?.id}_donebtn`}
            onClick={() => handleClose("save")} variant="contained"
            className={`${classes.subformButtonFontSize} ${classes.myCustomButton}`}
            style={{  
              fontFamily:`${
              props?.subFormData?.pageStyle && props?.subFormData?.pageStyle["FooterFontFamily"] ? props?.subFormData?.pageStyle["FooterFontFamily"]:"Open Sans"
          }`,
          fontSize:`${
              props?.subFormData?.pageStyle && props?.subFormData?.pageStyle["FooterFontSize"] ? props?.subFormData?.pageStyle["FooterFontSize"]:"12px"
          }`,
          fontWeight:`${
              props?.subFormData?.pageStyle && props?.subFormData?.pageStyle["FooterFontStyleWeight"] ? props?.subFormData?.pageStyle["FooterFontStyleWeight"]:"SemiBold"
          }`,
          backgroundColor:`${
            props?.subFormData?.pageStyle && props?.subFormData?.pageStyle["ButtonBackgroundColor"] ? props?.subFormData?.pageStyle["ButtonBackgroundColor"]:"rgb(0, 114, 198)"
        }`,
          color:`${
              props?.subFormData?.pageStyle && props?.subFormData?.pageStyle["FooterFontColor"] ? props?.subFormData?.pageStyle["FooterFontColor"]:"white"
          }`,
          fontStyle:`${
              props?.subFormData?.pageStyle && props?.subFormData?.pageStyle["FooterFontStyle"] ? props?.subFormData?.pageStyle["FooterFontStyle"]:"SemiBold"
          }`,}}>
                                               {props?.subFormData?.pageStyle?.["subformLabel"] ? 
            (props?.subFormData?.pageStyle?.["subformLabel"] ) : t(`${"Done"}`)}
                                               
                                                </Button>
          </div>
        ):null}
      </Dialog>
    </div>}
    </div>
  );
};

export default ButtonSubFormDialog;
